<template>
    <md-field>
        <md-input
            type="search"
            clearable
            style="width: 250px"
            placeholder="Rechercher..."
            :value="searchQuery"
            @input="debounceInput"
        >
        </md-input>
    </md-field>
</template>

<script>
export default {
    name: "search-input",
    data() {
        return {
            searchQuery: ''
        }
    },
    methods: {
        debounceInput: _.debounce(function (e) {
            this.$emit('input', e)
        }, 500),
    }
}
</script>

<style scoped>

</style>
